import { useState, useEffect } from "react";
import Papa from "papaparse";

export default function ChurnTestViewer({ report, closeReport }) {
  const [tableData, setTableData] = useState([]);

  function formatRunDuration(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Pad each value with a leading zero if it's less than 10
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");

    if (formattedHours === "00") {
      return `${formattedMinutes}:${formattedSeconds}`;
    } else {
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }
  }

  function generateCSV() {
    let formattedRunDuration = formatRunDuration(report.run_duration);
    const tableRows = [
      ["CHURN TEST REPORT", ""],
      ["Report Start Time", new Date(report.time_started).toLocaleString()],
      ["Report Stop Time", new Date(report.time_completed).toLocaleString()],
      ["Jockey Pump Start PSI", `${report.jockey_start_psi}`],
      ["Jockey Pump Stop PSI", `${report.jockey_stop_psi}`],
      ["Fire Pump Start PSI", `${report.fire_pump_start_psi}`],
      [
        "Casing Relief Valve Functioning",
        report.casing_relief_functioning.toUpperCase(),
      ],
      ["Run Duration", `${formattedRunDuration}`],
      ["System PSI On Completion", `${report.system_psi_on_complete}`],
    ];
    setTableData(tableRows);
  }

  function downloadCSV() {
    const csv = Papa.unparse(tableData);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    let nameDate = new Date(report.time_started).toLocaleString();
    let name = `Churn Test ${nameDate}.csv`;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    generateCSV();
  }, []);

  return (
    <div className="margin-t-b-h">
      <div className="flex-align-row">
        <div className="churnTestViewerButton" onClick={() => closeReport()}>
          Back
        </div>
        <div className="churnTestViewerButton" onClick={downloadCSV}>
          Download
        </div>
      </div>
      {tableData.length > 0 && (
        <table border="1" className="churnTestTable">
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td className="churnTestTableCell" key={cellIndex}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
